import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { CheckCircle2, AlertTriangle, XCircle, PlugZap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errText } from "@/lib/api";

const STYLE = {
  ok: { cls: "text-emerald-700 bg-emerald-50 border-emerald-200", Icon: CheckCircle2 },
  warning: { cls: "text-amber-800 bg-amber-50 border-amber-200", Icon: AlertTriangle },
  error: { cls: "text-rose-700 bg-rose-50 border-rose-200", Icon: XCircle },
};

export const TestConnectionButton = ({ api, productId, apiBaseUrl, appApiKey, config = {} }) => {
  const [result, setResult] = useState(null);
  const test = useMutation({
    mutationFn: async () => (await api.post("/admin/products/test-connection", { ...config, api_base_url: apiBaseUrl, app_api_key: appApiKey || "", product_id: productId || null })).data,
    onMutate: () => setResult(null),
    onSuccess: setResult,
    onError: (e) => setResult({ level: "error", message: errText(e, "Verifica non riuscita") }),
  });
  const s = result && (STYLE[result.level] || STYLE.error);
  return (
    <div className="space-y-2">
      <Button type="button" variant="outline" size="sm" disabled={test.isPending || !apiBaseUrl} onClick={() => test.mutate()} data-testid="btn-test-connection">
        <PlugZap size={14} className="mr-1" /> {test.isPending ? "Verifica in corso…" : "Verifica collegamento"}
      </Button>
      {s && (
        <div className={`flex items-start gap-2 text-xs border rounded-md px-3 py-2 ${s.cls}`} data-testid="test-connection-result">
          <s.Icon size={14} className="mt-0.5 shrink-0" />
          <span>{result.message}{result.status_code ? ` (HTTP ${result.status_code})` : ""}</span>
        </div>
      )}
    </div>
  );
};
